export enum SiteRegion {
    QA = 'QA',
    STAGE = 'STAGE',
    CN = 'CN',
    US = 'US',
    EU = 'EU',
}

export function getSiteRegion() {
    const mockRegion = localStorage.getItem('debug_region');
    if (mockRegion) {
        return mockRegion?.toUpperCase() as SiteRegion;
    }
    const origin = window.location.origin;
    if(origin.indexOf('qa-eureka.zhihuiya.com') > -1) {
        return 'QA';
    }else if (origin.indexOf('stage-eureka.zhihuiya.com') > -1) {
        return 'STAGE';
    }else if (origin.indexOf('eureka.zhihuiya.com') > -1) {
        return 'CN';
    }else if (origin.indexOf('eureka.patsnap.com') > -1) {
        return 'US';
    }else if (origin.indexOf('eureka.patsnap.eu') > -1) {
        return 'EU';
    }
    return 'QA';
}

export function getIsOverseas() {
    const siteRegion = getSiteRegion();
    return !['QA', 'CN'].includes(siteRegion);
}
